import DatePage, { getServerSideProps } from 'pages/[lang]/date';

export default DatePage;

export { getServerSideProps };
